import React, { useEffect, useState } from "react";

// Style
import "./Landing.scss";
import './SectionHighlight.scss';

// Redux
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";

// components
import Banner from "./components/Banner";
import HelmetCeo from 'components/HelmetCeo';
import BuildFuture from "./components/BuildFuture";
import CompoundLib from "./components/CompoundLib";
import ErrorBoundary from "components/ErrorBoundary";
import SliderComponent from "components/SliderComponent";
import FrequentCustom from "./components/FrequentCustom";

// Lib
import { useWindowSize } from "lib/hooks";

// Constants
import { configCeo } from "constans/landing";

// Actions
import * as actionsCreator from "./reducer";

export const Main: React.FC = () => {
  const dispatch = useAppDispatch();
  
  const { main, libraries } = useAppSelector(
    (store) => {
      return {
        main: store.main.data,
        libraries: store.libraries,
      };
    },
    shallowEqual
  );

  const [widthCarousel, setWidthCarousel] = useState<number>(0);

  useEffect(() => {
    dispatch(actionsCreator.getHighlightCarousel());
  }, []);

  useEffect(() => {
    const htmlWrapperSmallSlider = document.querySelector(".s1__small-slider");

    if (htmlWrapperSmallSlider) {
      setWidthCarousel(htmlWrapperSmallSlider?.clientWidth);
    }
  }, [libraries?.data]);

  const handlerClickCart = (id: string) => {
    id && window.open(`${window.location.origin}/molecule-product/${id}`, '_blank');
  };

  const settings = {
    isArrows: true,
    slidesToShow: 4,
    centerMode: false,
    lazyLoad: 'ondemand',
    width: widthCarousel,
    lengthArray: main?.length,
    infinite: !!(main?.length || 0 > 3),
    className: "section-high-light__wrapper-hightlight"
  };

  const { width } = useWindowSize();
  const isDesktop = width <= 1024;

  return (
    <ErrorBoundary>
      <React.Fragment>
        <HelmetCeo data={configCeo} />
        <Banner />

        {!!main?.length && <SliderComponent
          data={main}
          settings={settings}
          isMobile={isDesktop}
          title="New Highlights"
          handlerClick={handlerClickCart}
          className="section-high-light__hight section-high-light__wrapper relative mb30"
        />}

        <CompoundLib />
        <BuildFuture />
        <FrequentCustom />
      </React.Fragment>
    </ErrorBoundary>
  );
};

export default Main;
